import { useEffect } from "react";
import { useParams, useSearchParams, useNavigate } from "react-router-dom";
import useInputKeys from "hooks/useInputKeys";
import Screen from "components/TimelinePageOne/Screen";
import Bare from "components/TimelinePageOne/Bare";
import Keyboard from "components/TimelinePageOne/Keyboard";
import Switch from "components/TimelinePageOne/Switch";
import TimelinePageOneBG from "assets/images/timeline_page_one_bg.png";
import "./index.scss";

function TimelinePageOne() {
  const { param } = useParams();
  const navigate = useNavigate();

  const [searchParams, setSearchParams] = useSearchParams();

  const {
    setActiveTab,
    currentTimelineId,
    setSharedFaalId,
    setStrInput,
    setCurrentFrequency,
    expand,
    currentBare,
    currentTimeline
  } = useInputKeys();

  useEffect(() => {
    if (param) {
      if (param === "faal") {
        const fId = searchParams.get("fid");
        !!fId && setSharedFaalId(fId);
        setActiveTab("3");
      } else if (param === "search") {
        const q = searchParams.get("q");
        setStrInput(!!q ? q : "");
        setActiveTab("1");
      }
      else {
        setActiveTab("2");
      }
      setTimeout(() => {
        navigate("/");
      }, 100);
    }
  }, [
    searchParams,
    param,
    setActiveTab,
    currentTimelineId,
    setSharedFaalId,
    setSearchParams,
    setCurrentFrequency,
    navigate,
    setStrInput,
  ]);

    useEffect(()=> {
      if(currentTimeline?.timelineId)
    navigate(
      `?fr=${currentTimeline.frequency}&tl=${currentTimeline.timelineId}&b=${currentBare}`,
      { replace: true },
    );
  }, [currentTimeline, currentTimelineId, currentBare, navigate])

  return (
    <div className="screen">
      <div className="page-one">
        <div className="layout-page-one">
          <div className="main-wrapper">
                <img
                  src={TimelinePageOneBG}
                  alt="Timeline Page one Background"
                  className="background"
                />
                {/* space div */}
                
                <div className={`spacer-div`}>
                  <nbsp/>
                </div>

                <div className={(expand)?"top-box-expanded":`top-box`} >
                  <Screen />
                </div>

            <div className={`middle-box`}>
              <div className="bare-box">
                <Bare />
              </div>
              <div className="dial-box">
                <Keyboard />
              </div>
            </div>
            <div className={`bottom-box`}>
              <div className="switch-box">
                <Switch />
              </div>
            </div>
            </div>
        </div>
      </div>
    </div>
  );
}

export default TimelinePageOne;
